import { createContext } from 'react'
//Bank details
const bankContext = createContext()

export default bankContext
